import React, { useState, useEffect } from "react";
import {
  Tag,
  Classes,
  Drawer,
  Button,
  Collapse,
  Callout,
  Icon,
  FormGroup,
  ControlGroup,
  InputGroup,
  Divider,
  Tooltip,
  Dialog,
} from "@blueprintjs/core";
import { Trans } from "react-i18next";
import {
  authenticatedPostFetch,
  authenticatedGetFetch,
  authenticatedDeleteFetch,
  authenticatedPutFetch,
} from "../../utils/AuthenticatedFetch";

function CollapseIcon(val) {
  return val ? <Icon icon="chevron-up" /> : <Icon icon="chevron-down" />;
}

function Person(props) {
  const [Open, setOpen] = useState(false);
  const [Title, setTitle] = useState("...");
  const [Name, setName] = useState(props.name);
  const [Number, setNumber] = useState(props.number);

  useEffect(() => {
    setTitle(Name || "...");
  }, [Name, Number]);

  return (
    <div>
      <Button
        icon="person"
        rightIcon={CollapseIcon(Open)}
        alignText="left"
        fill={true}
        onClick={() => setOpen(!Open)}
      >
        {Title}
      </Button>
      <Collapse isOpen={Open}>
        <FormGroup label={<Trans>name</Trans>} inline={true}>
          <ControlGroup fill={true}>
            <InputGroup
              defaultValue={props.name}
              onChange={(ti) => setName(ti.target.value)}
            />
            <Tooltip
              content={
                <Trans>
                  name that corresponds to the number indicated below
                </Trans>
              }
            >
              <Icon icon="info-sign" />
            </Tooltip>
          </ControlGroup>
        </FormGroup>
        <FormGroup label={<Trans>phone number:</Trans>} inline={true}>
          <ControlGroup fill={true}>
            <InputGroup
              defaultValue={props.number}
              onChange={(ti) => setNumber(ti.target.value)}
            />
            <Tooltip
              content={<Trans>phone number associated with the name</Trans>}
            >
              <Icon icon="info-sign" />
            </Tooltip>
          </ControlGroup>
        </FormGroup>
        <Button
          icon="trash"
          onClick={() =>
            authenticatedDeleteFetch(
              "/phonie/contact",
              { index: props.index },
              () => {
                props.refresh();
              }
            )
          }
        />
        <Button
          icon="floppy-disk"
          onClick={() =>
            authenticatedPutFetch(
              "/phonie/contact",
              { index: props.index, name: Name, number: Number },
              () => {
                props.refresh();
              }
            )
          }
        />
      </Collapse>
    </div>
  );
}

export default function Contacts(props) {
  const [Open, setOpen] = useState(false);
  const [People, setPeople] = useState(undefined);
  const [Adding, Add] = useState(false);

  const [createName, setCreateName] = useState("");
  const [createNumber, setCreateNumber] = useState("");
  const [createError, setCreateError] = useState(false);

  function refresh() {
    authenticatedGetFetch("/phonie/contacts", (people) => {
      const ret_p = [];
      for (let person of people) {
        ret_p.push(
          <Person
            key={person.index}
            index={person.index}
            name={person.name}
            number={person.number}
            refresh={() => refresh()}
          />
        );
      }
      setPeople(ret_p);
    });
  }

  useEffect(() => {
    if (Open) refresh();
  }, [Open]);

  return (
    <div>
      <Tag
        large={true}
        round={true}
        icon="team"
        interactive={true}
        onClick={() => {
          setOpen(true);
        }}
      />
      <Drawer
        isOpen={Open}
        onClose={() => setOpen(false)}
        icon="team"
        title={<Trans>contacts</Trans>}
        isCloseButtonShown={true}
        canOutsideClickClose={true}
        canEscapeKeyClose={true}
        autoFocus={false}
        enforceFocus={true}
      >
        <div className={Classes.DRAWER_BODY}>
          <Callout
            className={Classes.DRAWER_FOOTER}
            intent="success"
            icon={null}
          >
            {People}
            <Divider />
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: "5px",
              }}
            >
              <Button
                icon="plus"
                onClick={() => {
                  Add(true);
                  setCreateName("");
                  setCreateNumber("");
                }}
              ></Button>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: "5px",
              }}
            ></div>
          </Callout>
        </div>
      </Drawer>

      {/* adding dialog */}
      <Dialog
        isOpen={Adding}
        icon="new-person"
        title={<Trans>add a contact</Trans>}
        onClose={() => Add(false)}
      >
        <div className={Classes.DIALOG_BODY}>
          <FormGroup label={<Trans>name</Trans>} labelFor="phone-number">
            <InputGroup
              type="tel"
              id="phone-number"
              placeholder="Henry"
              value={createName}
              onChange={(ti) => {
                setCreateName(ti.target.value);
              }}
            />
          </FormGroup>
          <FormGroup
            label={<Trans>phone number</Trans>}
            labelFor="phone-number"
          >
            <InputGroup
              type="tel"
              id="phone-number"
              placeholder="0123456789"
              value={createNumber}
              onChange={(ti) => {
                setCreateNumber(ti.target.value);
              }}
            />
          </FormGroup>
          <Callout intent="danger" hidden={!createError}>
            <Trans>TODO: error creatin new contact, check your inputs</Trans>
          </Callout>
        </div>
        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button icon="undo" intent="danger" onClick={() => Add(false)}>
              <Trans>cancel</Trans>
            </Button>
            <Button
              icon="send-to"
              onClick={() => {
                authenticatedPostFetch(
                  "/phonie/contact",
                  {
                    name: createName,
                    number: createNumber,
                  },
                  () => {
                    refresh();
                    Add(false);
                  },
                  () => setCreateError(true)
                );
              }}
            >
              <Trans>send</Trans>
            </Button>
          </div>
        </div>
      </Dialog>
    </div>
  );
}
